module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_4.02cb6ed0.png";